import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { mongo } from '@adornis/buchungsheld-db/server/mongo.js';
import { User } from '@adornis/buchungsheld-db/entities/user.js';
import { GLOBAL_CONTEXT } from '@adornis/users/db/a-roles.js';
import { assignRoleToUser } from '@adornis/users/server/roles.js';
import { createNewUser } from '@adornis/users/server/util.js';
import { MatchingWeekRole } from '../db/enums/roles.js';
import { normalizeSingleEmail } from '../shared/email.js';
import { assertCallerIsAdmin } from './admin-guard.js';

export const registerMwAdminUser = registerMutation({
  operationName: 'registerMwAdminUser',
  type: () => Boolean,
  params: [
    { name: 'email', type: () => String },
    { name: 'password', type: () => String },
    { name: 'firstName', type: () => String },
    { name: 'lastName', type: () => String },
  ],
  resolve: (email: string, password: string, firstName: string, lastName: string) => async () => {
    await assertCallerIsAdmin();
    const normalizedEmail = normalizeSingleEmail(email);
    const col = mongo().collection(User._collectionName);
    const selector = { $regex: `^${normalizedEmail.replace(/([^\w]{1})/g, '\\$1')}$`, $options: 'i' };
    const existing = await col.findOne({ email: selector });
    if (existing) throw new Error('Email already in use');

    const user = new User({
      email: normalizedEmail,
      username: normalizedEmail,
      firstName: firstName.trim(),
      lastName: lastName.trim(),
    } as any);
    const userID = await createNewUser(user as any, password.trim(), false);
    await assignRoleToUser(userID, MatchingWeekRole.ADMIN, [GLOBAL_CONTEXT], User as any);
    return true;
  },
});
